const ethers = require("ethers");
const BN = require("bignumber.js");

BN.prototype.scaleUp = function(decimals) {
  return this.times(BN(10).pow(decimals));
};

BN.prototype.scaleDown = function(decimals) {
  return this.div(BN(10).pow(decimals));
};

const getPositionAt = require("./lib/get-position-at");
const Provider = require("./lib/provider");
const Wallet = require("./lib/wallet");
const PnL = require("./lib/pnl");
const constants = require("./constants");
const utils = require("./lib/utils");
const graph = require("./lib/graph");

module.exports = {
  getPositionAt,
  constants,
  Provider,
  Wallet,
  PnL,
  ethers,
  BN,
  utils,
  graph,
};
